/* CONSTANTS FILE - CONSISTS ALL THE STATIC CONTENT TEXTS */

const content = {};

export const HERO_TEXT = 'Welcome to Minganic Designs, where minimalism meets organic design. We create spaces that are both simple and elegant, functional and sustainable. Our philosophy is to embrace the beauty of natural materials and create spaces that promote a sense of calm and tranquility.';

export const LEFT_TEXT = `Mindful . Harmonious\nNatural . Ingenious . Simple`;
export const RIGHT_TEXT = `The best rooms have something to say about the people who live in them\n- David Hicks`;
export const MASONRY_TITLE = 'Our Beloved Works';
export const MASONRY_TEXT = 'Design is not just what you see, but also\n what you feel';
export const TESTIMONIALS = 'Our Testimonials';

/* ABOUT US PAGE */
export const ABOUT_US = 'Minganic Designs was founded on the principles of minimalism, organic design, and sustainability. Our journey began with a shared passion for creating spaces that were both functional and beautiful, while remaining true to our commitment to environmental responsibility.';

export const MISSION = `Our mission is to imbue our clients' spaces with the benefits of minimalism and organic design to promote wellness and inspiration. Our aim is to create spaces with combining creativity, attention to detail, and a deep understanding of our clients' values and aspirations.`;

export const VISION = 'Our vision is to create designs that reflect the purity and simplicity of nature, while incorporating modern and functional design elements. We believe that by embracing organic materials and sustainable practices, we can create spaces that are not only beautiful but also environmentally responsible.';

// We cater to your needs with our emotion and heart into it!
export const ABOUT_SUB_TITLE = 'We cater to your needs with our emotions and hearts fully invested!';
export const RESIDENTIAL_TEXT =
    `From scratch to makeovers, we have expertise in
all residential works.
We also provide design inspirations.`;

export const COMMERCIAL_TEXT = `We design offices, shared workspaces, cabinets,
 stores and everything that's required.`;

export const RESTAURANT_TEXT = `We cover a range of services including
all types of restaurants, bistros and cafes.`;

export const CUSTOMERS_TITLE = `You've become a part of our family, and we thrive on your support and appreciation!`;

export const FOOTER_RIGHT_TITLE = `Transform your \nspace wonderfully!`;

// export const CONTACT_TITLE = `Let's transform your space into a\nhaven of minganic luxury! `;
export const CONTACT_TITLE = `Revamp your space into a haven of minganic luxury!\nLet's Connect `;